const SDK_VERSION = '7.44.2';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
